import script from "./TabNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./TabNavigation.vue?vue&type=script&setup=true&lang=js"

import "./TabNavigation.vue?vue&type=style&index=0&id=58a2adba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58a2adba"]])

export default __exports__